import keyBy from 'lodash/keyBy';

export default function updateProperties(
    {properties}: UpdateFolderPropertiesAction,
    setFolders: React.Dispatch<React.SetStateAction<{[localId: string]: Folder}>>
) {
    const data = Array.isArray(properties) ? properties : [properties];

    setFolders((latestFolders) => {
        const updates = data.map((folder: PartialFolderProperties) => ({
            ...latestFolders[folder.localId],
            ...folder,
        }));

        return {
            ...latestFolders,
            ...keyBy(updates, (folder) => folder.localId),
        };
    });

    return data.map((folder) => folder.localId);
}
